import React, { useEffect, useState } from 'react';
import { Col, Row, Tab, Tabs, Card } from 'react-bootstrap';
import ProfileBanner from 'components/common/ProfileBanner';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { showGuardian } from 'redux/features/guardians/actions';
import { useDispatch } from 'react-redux';
import { STATUSES } from 'common/constants';
import Loader from 'components/common/Loader';
import Header from 'components/common/Header';
import ProfileCard from './partials/ProfileCard';
import PersonalInfo from './partials/PersonalInfo';
import GuardianStudents from './partials/GuardianStudents';

const ShowGuardian = () => {
  const dispatch = useDispatch();
  const { id } = useParams();

  const [guardianData, setGuardianData] = useState({});

  const [key, setKey] = useState('overview');

  const { singleGuardian: guardian, status } = useSelector(
    state => state.guardian
  );

  useEffect(() => {
    dispatch(showGuardian(id));
  }, [dispatch]);

  useEffect(() => {
    setGuardianData(guardian);
  }, []);

  console.log('Guardian', guardian);
  console.log('status', status);
  console.log('status', guardianData);

  return status === STATUSES.LOADING ? (
    <Card>
      <Loader />
    </Card>
  ) : (
    <div>
      <Header
        title="Guardian Details"
        icon="street-view"
        btnLink="/"
        btnTitle="Go Back"
      ></Header>

      <ProfileCard data={guardian} />

      <ProfileBanner>
        <Tabs id="guardians-tabs" activeKey={key} onSelect={k => setKey(k)}>
          <Tab
            eventKey="overview"
            title="Overview"
            className="border-bottom border-x p-3"
          >
            <ProfileBanner.Body>
              <Row>
                <Col lg={6}>
                  <PersonalInfo data={guardian} />
                </Col>
                <Col lg={6}>
                  <GuardianStudents data={guardian} />
                </Col>
              </Row>
            </ProfileBanner.Body>
          </Tab>
          <Tab
            eventKey="payments"
            title="Billing & Payments"
            className="border-bottom border-x p-3"
          >
            <strong className="text-warning">Payments coming soon.</strong>
          </Tab>
        </Tabs>
      </ProfileBanner>
    </div>
  );
};

export default ShowGuardian;
